import React, { useState, useCallback, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { makeStyles } from "@material-ui/core/styles";
import Scroll from 'react-scroll';
import {
	useForm,
	Controller,
	useFieldArray,
	useController,
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import {
	Radio,
	RadioGroup,
	FormControlLabel,
	FormLabel,
	FormGroup,
	FormControl,
	Button,
	Box,
	InputLabel,
	MenuItem,
	Select,
	Checkbox,
	Typography,
	MenuList,
	Menu,
	TextField
} from "@material-ui/core";

import { MyLocation } from "@material-ui/icons";
import restrictedZone from "../../images/restrictedZone.svg";
import prohibitedZone from "../../images/prohibitedZone.svg";
import busLane from "../../images/busLane.svg";
import closeRoad from "../../images/closeRoad.svg";

import "./LocationDetail.scss";

import {
	Navbar,
	Header,
	StepHeader,
	FormBox,
	BootstrapInput,
	FileInput,
	Footer,
	Modal,
	Map,
} from "../../components/_index";
import { useYupValidationResolver } from "../../YupValidationResolver";
import ErrorsContainer from "../../components/ErrorsContainer/ErrorsContainer";
import { Autocomplete } from '@material-ui/lab';
import { checkIfRedirect, isEmpty } from "../../utils";
import errorWarning from '../../images/icon_warning.gif'

const districtList = [
	"step3.location.Central_and_Western",
	"step3.location.Eastern",
	"step3.location.Southern",
	"step3.location.Wan_Chai",
	"step3.location.Sham_Shui_Po",
	"step3.location.Kowloon_City",
	"step3.location.Kwun_Tong",
	"step3.location.Wong_Tai_Sin",
	"step3.location.Yau_Tsim_Mong",
	"step3.location.Islands",
	"step3.location.Kwai_Tsing",
	"step3.location.North",
	"step3.location.Sai_Kung",
	"step3.location.Sha_Tin",
	"step3.location.Tai_Po",
	"step3.location.Tsuen_Wan",
	"step3.location.Tuen_Mun",
	"step3.location.Yuen_Long"
];

const permitTypeOpt = [
	{
		id: "restricted",
	},
	{
		id: "prohibited",
	},
	{
		id: "bus",
	},
	{
		id: "close",
	},
];

export default withTranslation()(function LocationDetail({ t, i18n }) {
	let scroll = Scroll.animateScroll;
	const { setValues, data } = useData();
	const [open, setOpen] = useState([false]);
	const [ lang, setLang ] = useState(i18n.language);
	const [ streetNameOptions, setStreetNameOptions ] = useState([]);
	const [ customError, setCustomError ] = useState([]);

	const history = useHistory();

	checkIfRedirect(data, history);
	
	const useStyles = makeStyles(theme => ({
	    uppercase: {
	      textTransform: "uppercase"
	    }
	}));
	const classes = useStyles();
	
	const schema = yup.object().shape({
		locationDetail: yup.string().required(t("errors.frontend.790-E-0500")),
		locationGp: yup.array().min(1, console.log('error message')).ensure().of(
			yup.object().shape({
				streetNo: yup.string().test("number", t("errors.frontend.790-E-0505"), (streetNo)=>{
					const regex = new RegExp('^(\d*(-|,)?\w?(-|,)?\w?)|(\d*(-|,)?\w?(-|,)?\w?)$');
					return !streetNo||regex.test(streetNo);
			}).required(t("errors.frontend.790-E-0501")),
				streetName: yup.string().required(t("errors.frontend.790-E-0502")),
				district: yup.string().required(t("errors.frontend.790-E-0503")),
				permitType: yup.string().required(t("errors.frontend.790-E-0504")),
			})
		),
	});

	const {
		register,
		handleSubmit,
		control,
		errors,
		clearErrors,
		watch,
		reset,
		getValues,
	} = useForm({
		defaultValues: {
			locationDetail: data.locationDetail || "direct",
			locationGp: (!data.locationGp||data.locationGp.length<1) ?
					[
						{
							streetNo: "",
							streetName: "",
							district: "",
							remarks: "",
							permitType: "restricted",
							openMap: false,
						},
					]
				: data.locationGp.map((obj) => {
						return {
							streetNo: obj.streetNo,
							streetName: obj.streetName,
							district: obj.district,
							remarks: obj.remarks,
							permitType: (typeof obj.permitType?.find !== "undefined") ? (obj.permitType?.find((permit) => (permit.selected))?.id) : "restricted" ,
							openMap: obj.openMap || false,
						};
					}),
		},
		mode: "onSubmit",
		// resolver: yupResolver(schema),
		resolver: useYupValidationResolver(schema),
	});

	const { fields, append, remove } = useFieldArray(
		{
			control,
			name: "locationGp",
			// keyName: "key"	do not uncomment this or else remove and reset function will not work properly
		}
	);

	const locationDetailSelected = watch("locationDetail");
	const locationGpWatch = watch("locationGp");

	const addLocation = () => {
		if (fields.length >= 10) return;
		console.log("addLocation fields: ", fields);
		console.log("addLocation data: ", data);
		append({
			streetNo: "",
			streetName: "",
			district: "",
			remarks: "",
			permitType: "restricted",
			openMap: false,
		});
	};

	const onSubmit = (data) => {
		console.log("onSubmit data: ", data);
		console.log("onSubmit fields: ", fields);
		const locationGp = data.locationGp.map((location)=>({...location, permitType: permitTypeOpt.map((permit)=>({...permit, selected: permit?.id===location.permitType}))}));
		setValues({...data, locationGp});
		history.push(`${process.env.REACT_APP_SUB_ROUTE}/permitDetail`);
	};

	const onError = (errors) => {
		setCustomError([]);
		scroll.scrollToTop();
	}

	const handleState = async (newLocationGp) => {
		if(newLocationGp && newLocationGp["locationGp"].length>0){
			let emptyRecord = 0;
			if(isEmpty(locationGpWatch[0].streetNo)&&isEmpty(locationGpWatch[0].streetName)&&isEmpty(locationGpWatch[0].district)&&isEmpty(locationGpWatch[0].Remarks)){
				emptyRecord = 1;
			}
			if(newLocationGp["locationGp"].length<=(10-locationGpWatch.length+emptyRecord)){
				Promise.all(newLocationGp && newLocationGp["locationGp"].map((locationGp) => {
					append(locationGp);
				}))
				.then(() => {
					let newState = {
						...data,
						locationDetail: 'direct',
					};
					setValues(newState);
				})
				if(emptyRecord==1){
					remove(0);
				}
			} else {
				setCustomError({"locationGpLimit": {"message": t('step3.location.locationLimit')}});
				scroll.scrollToTop();
			}
		} 
	};

	const handleReset = () => {
		scroll.scrollToTop();
		clearErrors();
		let newState = {
			locationDetail: "direct",
			locationGp: [
				{
					streetNo: "",
					streetName: "",
					district: "",
					remarks: "",
					permitType: "restricted"
				},
			],
		};
		setValues(newState);

		reset({
			locationDetail: "direct",
			locationGp: [
				{
					streetNo: "",
					streetName: "",
					district: "",
					remarks: "",
					permitType: "restricted"
				}
			]
		})
	};

	const handleBack = () => {
		history.push(`${process.env.REACT_APP_SUB_ROUTE}/vehicleDetail`);
	};

	const handleOpen = (fieldIndex) => {
		let openClone = [];
		console.log(data, fields)
		fields && fields.forEach((open, index) => {
			const key = open && open.key;
			//	 openClone.push({ [key]: index == fieldIndex });
			openClone.push(index == fieldIndex);
		});
		setOpen(openClone);
	};

	const handleClose = (fieldIndex) => {
		let openClone = [];
		fields.forEach((open) => {
			const key = open && open.key;
			//	 openClone.push({ [key]: false });
			openClone.push(false);
		});
		console.log("handleClose openClone: ", openClone);
		setOpen(openClone);
	};

	const handleRemoveItem = (index) => {
			console.log('before delete: index', index,'fields: ', fields,'data.locationGp: ', data.locationGp)
			remove(index)
			console.log('after delete: fields ', fields,'data.locationGp: ', data.locationGp)
			console.log('after delete and return ', {data, fields})
	}

	useEffect(() => {
		scroll.scrollToTop();
		const URL = `${window.location.origin}/EPASService/application/selectStreetName`;
		let postOption = {
			method: 'POST',
			body: JSON.stringify({lang: "eng", prefix: ""})
		}
		fetch(URL, postOption)
		.then((response)=>(response.json()))
		.then((json)=>{
			setStreetNameOptions(json.data.map((street)=>(street.chi_name)).concat(json.data.map((street)=>(street.eng_name))));
		})
		.catch((reason)=>(console.log("fetch error, reason: ", reason)));
	}, [])

	console.log("before render fields: ", fields);
	console.log('field array data', data)
	console.log("before render open: ", open);

	console.log("errors: ", errors);
	
	const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
	const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }

	return (
		<main>
			<Helmet>
				<title>{`Screen ID: SC-790-`+siteID()+'-006'}</title>
			</Helmet>
			<Box className="wrapper locationDetail">
				<Header onLangChange={setLang} langLock="langLocked" />
				<Box className="mainWrapper">
					<Navbar step="step3" />
					<Box className="contentWrapper">
						<ErrorsContainer errors={{...errors, ...customError}} />
						<StepHeader
							step="common.step3"
							title="step3.locationTitle"
							pointsToNote3
							mandatory
						/>
						<form
							onSubmit={handleSubmit(onSubmit, onError)}
							onReset={handleReset}
							noValidate
						>
							<FormBox header="step3.location.title">
								<Box p={5}>
									<Box mb={6}>
										<FormControl
											component="fieldset"
											error={!!errors["locationGp"]}
										>
											<FormLabel component="legend">
												{t("step3.location.locationDetail")}{" "}
												<span className="danger">*</span>
												{!!errors["locationGp"] ? <img id="locationGp_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
											</FormLabel>
											<Controller
												control={control}
												name="locationDetail"
												defaultValue={data.locationDetail}
												as={
													<RadioGroup row aria-label="locationDetail">
														<FormControlLabel
															value="direct"
															control={<Radio />}
															label={t("step3.location.locationDetailOpt1")}
														/>
														<FormControlLabel
															value="upload"
															control={<Radio />}
															label={t("step3.location.locationDetailOpt2")}
														/>
													</RadioGroup>
												}
											/>
										</FormControl>
									</Box>
								</Box>
								{
									fields && fields.map((item, index) => {
									console.log("VD locationGp loop: ", {index, item});
									return (
										<Box
											p={5}
											mb={5}
											key={item.id}
											bgcolor={
												index % 2 === 0
													? "repeatInput.main"
													: "repeatInput.secondary"
											}
										>
											<Box mb={6} className="addressWrapper">
												<FormControl
												className={"streetNo"+((!!errors["locationGp["+index+"].streetName"] || !!errors["locationGp["+index+"].district"]) && !!!errors["locationGp["+index+"].streetNo"] ?" streetNoMarginTopNoError":"")}
													error={
														!!errors["locationGp["+index+"].streetNo"]
													}
												>
													<div className="addressLabel">
														{t("step3.location.address")}{" "}
														<span className="danger">*</span>
														{!!errors["locationGp["+index+"].streetNo"] ? <img id={"locationGp["+index+"].streetNo_errorIcon"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
													</div>
													<InputLabel
														shrink
														className="streetLabel"
														htmlFor={`locationGp[${index}].streetNo`}
													>
														<span className="hiddenLabel">{t("step3.location.streetNo")}</span>
													</InputLabel>
													<BootstrapInput
													    id={`locationGp[${index}].streetNo`}
														name={`locationGp[${index}].streetNo`}
														defaultValue={isEmpty(item.streetNo)?"":item.streetNo}
														placeholder={t("step3.location.streetNo")}
														ref={register()}
														inputProps={{
															maxlength: 10,
															"aria-label": t("step3.location.streetNo")
														}}
													/>
												</FormControl>
												<FormControl
													className={"streetName"+(!!errors["locationGp["+index+"].streetName"] ?" streetNameMarginTopError":"")+((!!errors["locationGp["+index+"].streetNo"] || !!errors["locationGp["+index+"].district"]) && !!!errors["locationGp["+index+"].streetName"] ?" streetNameMarginTopNoError":"")}
													error={
														!!errors["locationGp["+index+"].streetName"]
													}
												>
													<InputLabel
														shrink
														htmlFor={`locationGp[${index}].streetName`}
													>
														<span className="hiddenLabel">{t("step3.location.streetName")}</span>
														{!!errors["locationGp["+index+"].streetName"] ? <img id={"locationGp["+index+"].streetName_errorIcon"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
													</InputLabel>
													<Controller
														control={control}
														name={`locationGp[${index}].streetName`}
														defaultValue={isEmpty(item.streetName)?"":item.streetName}
														render={(props)=>{
															console.log("props: ", props);
															return <Autocomplete
																	id={`locationGp[${index}].streetName`}
																	aria-label={`locationGp[${index}].streetName`}
																	aria-expanded="false"
																	aria-owns={`locationGp[${index}].streetName`}
																	freeSolo
																	disableClearable
																	options={props.value.length>0?streetNameOptions.filter((streetName)=>(streetName.toLowerCase().startsWith(props.value.toLowerCase()))):[]}
																	className="streetNameAutoComplete"
																	defaultValue={isEmpty(item.streetName)?"":item.streetName}
																	onChange={(event, value, reason) => (props.onChange(value))}
																	onInputChange={(event, value, reason) => (props.onChange(value))}
																	renderInput={(params) => (
																		<TextField
																			id={`locationGp[${index}].streetName`}
																			{...params}
																			placeholder={t("step3.location.streetName")}
																			aria-label={`locationGp[${index}].streetName`}
																			InputProps={{ 
																				...params.InputProps, 
																				className: "streetNameInput", 
																				maxlength: 70,
																				"aria-label": `locationGp[${index}].streetName`,
																			}}
																		/>
																	)}
																/>
														}} />
												</FormControl>
												<FormControl
													className={"district"+(!!errors["locationGp["+index+"].district"] ?" districtMarginTopError":"")+((!!errors["locationGp["+index+"].streetNo"] || !!errors["locationGp["+index+"].streetName"]) && !!!errors["locationGp["+index+"].district"] ?" districtMarginTopNoError":"")}
													error={
														!!errors["locationGp["+index+"].district"]
													}
												>
													<InputLabel
														shrink
														htmlFor={`locationGp[${index}].district`}
													>
														<span className="hiddenLabel">{t("step3.location.district")}</span>
														{!!errors["locationGp["+index+"].district"] ? <img id={"locationGp["+index+"].district_errorIcon"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
													</InputLabel>
													<Controller
														control={control}
														name={`locationGp[${index}].district`}
														defaultValue={isEmpty(item.district)?"":item.district}
														render={(selectProps) => (
															<Select
																displayEmpty
																id={`locationGp[${index}].district`}
																{...selectProps}
																key={item.id}
																className={classes.uppercase}
																inputProps={{ 
																	"aria-labelledby": `locationGp[${index}].district` 
																}}
															>
																<MenuItem value="" className={classes.uppercase}>
																	{t("step3.location.district")}
																</MenuItem>
																{districtList.map((district, districtIdx) => (
																	<MenuItem
																		key={districtIdx}
																		value={t(district, {lng: "en"})}
																		className={classes.uppercase}
																	>
																		{t(district)}
																	</MenuItem>
																))}
															</Select>
														)}
													/>
												</FormControl>
												<Button
													aria-label="pin location"
													variant="contained"
													color="primary"
													className={"pinLocation"+(!!errors["locationGp["+index+"].district"] || !!errors["locationGp["+index+"].streetNo"] || !!errors["locationGp["+index+"].streetName"] ?" pinLocationError":"")}
													type="button"
													onClick={handleOpen.bind(this, index)}
												>
													<MyLocation />
												</Button>
												<Modal
													open={open[index] || false}
													onClose={handleClose.bind(this, index)}
													title=""
												>
													<Map
														streetNo={
															getValues(`locationGp[${index}].streetNo`) || null
														}
														streetName={
															getValues(`locationGp[${index}].streetName`) ||
															null
														}
													/>
												</Modal>
											</Box>
											<Box mb={6}>
												<FormControl className="remarks">
													<BootstrapInput
														id={`locationGp[${index}].remarks`}
														inputProps={{
															maxlength: 150,
															"aria-labelledby": `locationGp[${index}].remarks`
														}}
														name={`locationGp[${index}].remarks`}
														defaultValue={isEmpty(item.remarks)?"":item.remarks}
														ref={register()}
														placeholder={t("step3.location.remarks")}
													/>
												</FormControl>
											</Box>
											<Box mb={6}>
												<FormControl
													component="fieldset"
													error={!!errors["locationGp["+index+"].permitType"]}
												>
													<FormLabel component="legend">
														{t("step3.location.permitType")}{" "}
														<span className="danger">*</span>
														{!!errors["locationGp["+index+"].permitType"] ? <img id={"locationGp["+index+"].permitType_errorIcon"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
													</FormLabel>
													<FormGroup className="permitType">
													<Controller
														control={control}
														name={`locationGp[${index}].permitType`}
														id={`locationGp[${index}].permitType`}
														defaultValue={item.permitType}
														render={(props) => (
														<RadioGroup row aria-label="permitType" name={`locationGp[${index}].permitType`}
														value={props.value} onChange={(e) =>
															props.onChange(e.target.value)
														}>
														{permitTypeOpt.map((permit, j) => {
															return (
																<FormControlLabel
																	value={permit?.id}
																	control={<Radio/>}
																	label={t(`step3.location.permitTypeOpt.${permit.id}`)}
																/>
															);
														})}
														</RadioGroup>)}/>
													</FormGroup>
												</FormControl>
											</Box>
											{ locationGpWatch.length>1 &&
												index >= 0 &&
												<Button
													aria-label="Remove"
													variant="contained"
													color="primary"
													className="removeBtn"
													onClick={() => {
														console.log('item', item)
														handleRemoveItem(index);
													}}
												>
													{t("common.button.remove")}
												</Button>
											}
										</Box>
									);
								})}

								{
									locationDetailSelected === "direct" && fields && fields.length < 10 &&
									<Box p={5}>
										<Button
											aria-label={t("step3.location.addLocation")}
											variant="contained"
											color="primary"
											onClick={addLocation}
										>
											{t("step3.location.addLocation")}
										</Button>
										{t("step3.location.addLocationIfNeed")}
									</Box>
								}

								{
									locationDetailSelected === "upload" && (
									<Controller
										control={control}
										name="fileInput"
										render={(props) => (
											<Box p={5}>
												<Typography variant="body1">
													{t("step3.location.uploadDesc")}
												</Typography>
												<FileInput
													name="locationGpFiles"
													control={control}
													maxFiles="1"
													fileType=".xls, .xlsx"
													state={data}
													stateKey={"locationGp"}
													page="locationDetail"
													onChange={handleState}
												/>
											</Box>
										)}
									/>
								)}
							</FormBox>
							<FormBox header="step3.note.title">
								<Box p={5} bgcolor="tnc.main" className="permitList">
									<Box className="permitItm">
										<img src={restrictedZone} alt="" />
										<Typography variant="body1">
											{t("step3.note.restrictedZone")}
										</Typography>
									</Box>
									<Box className="permitItm">
										<img src={prohibitedZone} alt="" />
										<Typography variant="body1">
											{t("step3.note.prohibitedZone")}
										</Typography>
									</Box>
									<Box className="permitItm">
										<img src={busLane} alt="" />
										<Typography variant="body1">
											{t("step3.note.busLane")}
										</Typography>
									</Box>
									<Box className="permitItm">
										<img src={closeRoad} alt="" />
										<Typography variant="body1">
											{t("step3.note.closeRoad")}
										</Typography>
									</Box>
								</Box>
							</FormBox>
							<FormBox>
								<Box display="flex" justifyContent="flex-end">
									<Button
										variant="contained"
										color="secondary"
										className="secBtn"
										onClick={handleBack}
									>
										{t("common.button.back")}
									</Button>
									<Button
										variant="contained"
										color="secondary"
										className="secBtn"
										onClick={handleReset}
									>
										{t("common.button.clear")}
									</Button>
									<Button variant="contained" color="primary" type="submit">
										{t("common.button.next")}
									</Button>
								</Box>
							</FormBox>
						</form>
					</Box>
				</Box>
			</Box>
			<Footer />
		</main>
	);
});
